<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Reporte de Costos por Proveedor</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group"></div>
              </div>
              <div class="col-md-12">
                <ProveedoresSelectComponent :current="current" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="dropdown">
                  <button
                    v-if="current.proveedor"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    class="btn btn-info dropdown-toggle"
                    aria-expanded="false"
                  >
                    <i class="fas fa-download"></i>
                    Generar Reporte
                  </button>
                  <div
                    aria-labelledby="dropdownMenuButton"
                    class="dropdown-menu"
                    x-placement="bottom-start"
                    style="
                      position: absolute;
                      transform: translate3d(0px, 30px, 0px);
                      top: 0px;
                      left: 0px;
                      will-change: transform;
                    "
                  >
                    <a @click="imprimirXls(current)" class="dropdown-item"
                      ><i class="far fa-file-alt"></i> - XLS</a
                    >
                    <a @click="imprimir(current)" class="dropdown-item"
                      ><i class="far fa-file-alt"></i> - PDF</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    ProveedoresSelectComponent,
  },
  data() {
    return {
      incluir_en_blanco: true,
      current: {
        tienda: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {},
  mounted() {
    let self = this;
  },
  methods: {
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=compras/reportes/costos_proveedores.jrxml&proveedor_id=${current.proveedor.codigo}`
      );
    },
    imprimirXls(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=compras/reportes/costos_proveedores.jrxml&proveedor_id=${current.proveedor.codigo}`
      );
    },
  },
};
</script>
